import React from 'react';
import { observer } from 'mobx-react-lite';
import { HeaderUndoRedo } from '../editor/HeaderUndoRedo';
import { MenuCard } from "../menu/MenuCard";
import { EditorToolType, mapEditorComplexities, mainMapEditorStore } from "../../stores/MapEditorStore";
import { undoableSelectTool } from "../../stores/undo/operation/SetPlacementSelectionOp";
import { useTranslation } from "react-i18next";
import { ToolButton } from "./ToolButton";
import styled from "styled-components";
import { HiCursorClick } from "react-icons/hi";
import { BsPencil } from "react-icons/bs";
import { PlacementSelectorPlaneSelection, PlacementSelectorGamePreviewCheckmark } from './PlacementSelectorComponents';
import { undoableSetMapEditorComplexity } from '../../stores/undo/operation/MapEditorSetMapEditorComplexity';
import { userStore } from '../../stores/UserStore';
export const Container = styled.div.withConfig({
  displayName: "ToolsMenu__Container",
  componentId: "sc-vmq4gi-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;"]);
export const FloatLeftMenuCard = styled(MenuCard).withConfig({
  displayName: "ToolsMenu__FloatLeftMenuCard",
  componentId: "sc-vmq4gi-1"
})(["overflow:hidden;flex-shrink:0;display:flex;align-items:center;"]);
export const FloatLeft = styled.div.withConfig({
  displayName: "ToolsMenu__FloatLeft",
  componentId: "sc-vmq4gi-2"
})(["float:left;"]);
export const ToolsMenu = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    selectedTool
  } = mainMapEditorStore;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(FloatLeftMenuCard, null, /*#__PURE__*/React.createElement(HeaderUndoRedo, null)), /*#__PURE__*/React.createElement(FloatLeftMenuCard, null, /*#__PURE__*/React.createElement(ToolButton, {
    onChange: () => undoableSelectTool(mainMapEditorStore, EditorToolType.SingleSelect),
    text: t("editor.select"),
    icon: HiCursorClick,
    checked: selectedTool === EditorToolType.SingleSelect,
    floatLeft: true
  }), /*#__PURE__*/React.createElement(ToolButton, {
    onChange: () => undoableSelectTool(mainMapEditorStore, EditorToolType.PlaceAsset),
    text: t("editor.place_asset"),
    icon: BsPencil,
    checked: selectedTool === EditorToolType.PlaceAsset,
    floatLeft: true
  })), userStore.showMapComplexitySelector && /*#__PURE__*/React.createElement(FloatLeftMenuCard, null, t("editor.map_editor_complexity"), ": \xA0", /*#__PURE__*/React.createElement("select", {
    value: mainMapEditorStore.mapEditorComplexity,
    onChange: e => undoableSetMapEditorComplexity(e.target.value)
  }, mapEditorComplexities.map(complexity => /*#__PURE__*/React.createElement("option", {
    key: complexity,
    value: complexity
  }, t("editor.map_editor_complexity_" + complexity))))), /*#__PURE__*/React.createElement(FloatLeftMenuCard, null, /*#__PURE__*/React.createElement(PlacementSelectorGamePreviewCheckmark, {
    mapRelatedStore: mainMapEditorStore
  })), mainMapEditorStore.complexityShowHeightPlanes && /*#__PURE__*/React.createElement(FloatLeftMenuCard, null, /*#__PURE__*/React.createElement(PlacementSelectorPlaneSelection, {
    mapRelatedStore: mainMapEditorStore
  })));
});